howspace.widgets.onEvent('discussion:demo:started', (widget, notification) => {
    real.notification.show(howspace.translate('discussion_demo_started',
        {
            'item_count': notification.object.item_count,
        }), 'info', true);
});
